import {makeStyles} from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  buttonLink: {
    margin: theme.spacing(1, 0),
  },
  largePaperHeight: {
    minHeight: '100%',
  },
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 450,
    tableLayout: 'fixed',
  },
  tableWrapper: {
    height: 500,
    overflow: 'auto',
    overflowY: 'auto',
  },
  cancelButton: {
    width: '65px',
    padding: '0px 12px 0 16px',
  },
  cellRoot: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: '100px',
    maxWidth: '100px',
    textOverflow: 'ellipsis',
  },
}))

export default useStyles
